module.exports = __webpack_public_path__ + "static/img/f5.feadc2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui3/f5.png
// module id = HQGJ
// module chunks = 1